export default [
    {
        path: '/paypal/transactions-list',
        name: 'paypal_transactions_list',
        component: () => import('@src/paypal/paypal-transaction-list.vue'),
        meta: {
            title: 'Kontoauszug Paypal',
            role: 'ROLE_PAYMENT_MATCHING',
        },
    },
    {
        path: '/paypal/transaction-matching/:id',
        name: 'paypal_transaction_matching',
        component: () => import('@src/paypal/paypal-transaction-matching.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Kontoauszugszuordnung Paypal',
            role: 'ROLE_PAYMENT_MATCHING',
        },
    },
    {
        path: '/paypal/transaction-detail/:id',
        name: 'paypal_transaction_detail',
        component: () => import('@src/paypal/paypal-transaction-detail.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Kontoauszugszeile Paypal',
            role: 'ROLE_PAYPAL_TRANSACTION',
        },
    },
    {
        path: '/paypal/transactions-list/managed-by-accounting',
        name: 'paypal_transactions_list_managed_by_accounting',
        component: () => import('@src/paypal/paypal-transaction-list.vue'),
        props() {
            return {
                managedByAccounting: true,
            };
        },
        meta: {
            title: 'Kontoauszug Paypal - Buchhaltung',
            role: 'ROLE_PAYMENT_MATCHING',
            favoriteRouteName: 'paypal_transactions_list_managed_by_accounting',
        },
    },
];
